import { FC, useState } from "react";
import { useAlertStore, useThemeStore, useUserStore } from "../../../stores";
import { CashBuilderForm } from "../../../components/cash";
import { CashBuilder, CashType, Customer } from "../../../types";
import { CashBuilderFormPropsSetters } from "../../../components/cash/cash-builder-form/types";
import { Row } from "../../../components/containers";
import { JustifyContent } from "../../../components/containers/types";
import { Button } from "../../../components/buttons";
import { CashApi } from "../../../api";

const INIT_CASH_BUILDER_STATE: CashBuilder = {
  customer: null,
  description: "",
  image: null,
  total_price: 0,
  type: null,
};

const Cash: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const pushAlert = useAlertStore((s) => s.pushAlert);
  const hasUserAccess = useUserStore((s) => s.hasUserAccess);

  const [cashBuilder, setCashBuilder] = useState<CashBuilder>({
    ...INIT_CASH_BUILDER_STATE,
  });

  const [loading, setLoading] = useState<boolean>(false);

  const getSetters = (): CashBuilderFormPropsSetters => ({
    setCustomer: (v) =>
      setCashBuilder((prev) => ({ ...prev, customer: v as Customer | null })),
    setDescription: (v) =>
      setCashBuilder((prev) => ({ ...prev, description: v as string })),
    setImage: (v) =>
      setCashBuilder((prev) => ({ ...prev, image: v as FileList | null })),
    setTotalPrice: (v) =>
      setCashBuilder((prev) => ({ ...prev, total_price: v as number })),
    setType: (v) =>
      setCashBuilder((prev) => ({ ...prev, type: v as CashType | null })),
  });

  const onSubmit = (): void => {
    if (!hasUserAccess(["SpendCash"]))
      return pushAlert("دسترسی غیر مجاز", "error");

    if (
      !cashBuilder.type ||
      !cashBuilder.description ||
      !cashBuilder.total_price ||
      (cashBuilder.type.name === "received" && !cashBuilder.customer)
    ) {
      return pushAlert(
        "لطفا مطمئن شوید که فیلدها به درستی پر شده اند",
        "error"
      );
    }

    setLoading(true);

    CashApi.create(cashBuilder)
      .then(() => {
        setCashBuilder({ ...INIT_CASH_BUILDER_STATE });
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      style={{
        background: theme.overlay,
        borderRadius: 15,
        marginTop: "1rem",
        padding: "1rem",
      }}
    >
      <CashBuilderForm cashBuilder={cashBuilder} {...getSetters()} />

      <Row style={{ width: "100%" }} justifyContent={JustifyContent.End}>
        <Button
          onClick={onSubmit}
          loading={loading}
          background={theme.primary}
          color={theme.textOnprimary}
        >
          ثبت
        </Button>
      </Row>
    </div>
  );
};

export default Cash;
